<span *ngIf="localPost.name?.length > 0" (mouseover)="showLink = true" (mouseout)="startHideTimer()">
    <span class="user_identity_{{ localPost.identity }}">
        {{ localPost.name }}
        <div *ngIf="localPost.v_name?.length > 0">({{ localPost.v_name }})</div>
    </span>
</span>
<span *ngIf="localPost.name?.length === 0">未填寫</span>
<div *ngIf="showLink" (mouseover)="cancelHideTimer()" (mouseout)="startHideTimer()">

    <span *ngIf="localPost.uid?.length > 0 && power_id != 16">
        <a  href="{{ link }}/user/{{ localPost.uid }}" target="_blank">
            <i style="margin: 0 10px 0 0;" class="fas fa-user"></i>
        </a>
        <a  href="{{ link }}/user/{{ localPost.uid }};act=1" target="_blank">
            <i style="margin: 0 10px 0 0;" class="fas fa- fa-address-card"></i>
        </a>
        <a  href="javascript:void(0)" (click)="copyToClipboard(localPost)">
            <i style="margin: 0 10px 0 0;" class="fas fa- fa fa-share"></i>
        </a>
    </span>

	<span *ngIf="localPost.uid?.length > 0 && power_id == 16">
        <!-- <a  href="{{ link }}/user/{{ localPost.uid }}" target="_blank">
            <i style="margin: 0 10px 0 0;" class="fas fa-user"></i>
        </a> -->
        <a  href="{{ link }}/user/{{ localPost.uid }};act=1" target="_blank">
            <i style="margin: 0 10px 0 0;" class="fas fa- fa-address-card"></i>
        </a>
        <a  href="javascript:void(0)" (click)="copyToClipboard(localPost)">
            <i style="margin: 0 10px 0 0;" class="fas fa- fa fa-share"></i>
        </a>
    </span>

</div>
